import { render, staticRenderFns } from "./ManageAdvisors.vue?vue&type=template&id=49f7d3a4&"
import script from "./ManageAdvisors.vue?vue&type=script&lang=js&"
export * from "./ManageAdvisors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports